import React, {FC, useCallback, useEffect, useMemo, useState} from 'react';
import {Platform, View} from 'react-native';
import {root} from '../../../bootstrap';
import {viewLocaleHandler} from '../../../../locale/core/infrastructure/projection/viewLocale';
import {viewLocale} from '../../../../locale/core/projection/viewLocale';
import {viewCustomerHandler} from '../../../../customer/core/infrastructure/projection/viewCustomer';
import {viewCustomer} from '../../../../customer/core/projection/viewCustomer';
import {Customer} from '../../../../customer/core/projection/customer';
import {InfoBox} from '@lookiero/aurora';
import {useIntl} from 'react-intl';
import {style as lookAndLikeStyle} from './LookAndLike.style';
import {useNavigate} from 'react-router-native';
import {useHardwareBackPress} from '@components/hooks/useHardwareBackPress';
import {Locale, LookAndLikeProps, Tradename} from '@lookiero/look-and-like';
import {ConfigurationApplication} from '@application/Config';

const LookAndLike: FC<Omit<LookAndLikeProps, 'customerId'>> = ({onReady, ...props}) => {
  const {tradename} = ConfigurationApplication.retrieve();

  const [customer, setCustomer] = useState<Customer | null>();
  const [locale, setLocale] = useState<string>();

  const style = useMemo(() => lookAndLikeStyle(), []);

  const {formatMessage} = useIntl();
  const infoBoxText = formatMessage({id: 'lookandlike.inbobox.text'});

  const navigate = useNavigate();
  const onBack = useCallback(() => navigate(-1), [navigate]);
  useHardwareBackPress(onBack);

  const [infoBoxVisible, setInfoBoxVisible] = useState(false);

  const handleOnReady = useCallback(() => {
    setInfoBoxVisible(true);
    onReady?.();
  }, [onReady]);

  useEffect(() => {
    const loadDependencies = async (): Promise<void> => {
      setLocale(await viewLocaleHandler(viewLocale()));
      setCustomer(await viewCustomerHandler(viewCustomer()));
    };

    loadDependencies();
  }, []);

  const Root = useMemo(() => (customer ? root({customerId: customer.customerId}) : View), [customer]);

  return customer && locale ? (
    <>
      <Root
        {...props}
        tradename={tradename as unknown as Tradename}
        customerId={customer.customerId}
        locale={locale as Locale}
        onReady={handleOnReady}
      />

      {Platform.OS === 'web' && infoBoxVisible && <InfoBox text={infoBoxText} style={style.infoBox} />}
    </>
  ) : null;
};

export {LookAndLike};
